/**
 * three/webgpu uses `self.GPUShaderStage` when `self` is defined; if it is missing, the module throws
 * (e.g. reading undefined.VERTEX). Polyfill before any code imports three/webgpu (e.g. @thatopen/components).
 */
const GPU_SHADER_STAGE_FALLBACK = { VERTEX: 1, FRAGMENT: 2, COMPUTE: 4 };

const g = globalThis as typeof globalThis & {
  GPUShaderStage?: typeof GPU_SHADER_STAGE_FALLBACK;
};

if (g.GPUShaderStage == null) {
  g.GPUShaderStage = GPU_SHADER_STAGE_FALLBACK;
}

export {};
